import { Controller } from 'stimulus';

/**
 * Manages billing line item form interactions:
 * - Real-time total calculation (quantity × unit amount), negated for credit codes
 * - Show/hide add form
 */
export default class extends Controller {
  static targets = [
    'quantity',
    'unitAmount',
    'total',
    'addForm',
    'billingCode',
    'deviceModelWrapper',
    'deviceModel',
  ];
  static values = {
    currencySymbol: { type: String, default: '$' },
    creditCodeIds: { type: Array, default: [] },
  };

  onCodeChange() {
    this.toggleDeviceModelSelect();
    this.updateTotal();
  }

  updateTotal() {
    const qty = parseInt(this.quantityTarget.value) || 0;
    const unitAmount = parseFloat(this.unitAmountTarget.value) || 0;
    const magnitude = qty * unitAmount;
    const prefix = this.isCreditSelected() ? '- ' : '';
    this.totalTarget.textContent = `${prefix}${
      this.currencySymbolValue
    }${magnitude.toFixed(2)}`;
  }

  toggleDeviceModelSelect() {
    if (!this.hasDeviceModelWrapperTarget) return;
    const value = this.hasBillingCodeTarget ? this.billingCodeTarget.value : '';
    const isDeviceSentinel =
      typeof value === 'string' && value.startsWith('device:');
    if (isDeviceSentinel) {
      this.deviceModelWrapperTarget.classList.remove('d-none');
    } else {
      this.deviceModelWrapperTarget.classList.add('d-none');
      if (this.hasDeviceModelTarget) {
        this.deviceModelTarget.value = '';
      }
    }
  }

  isCreditSelected() {
    if (!this.hasBillingCodeTarget) return false;
    const selectedId = parseInt(this.billingCodeTarget.value);
    if (!selectedId) return false;
    return this.creditCodeIdsValue.includes(selectedId);
  }

  showAddForm(event) {
    event.preventDefault();
    if (this.hasAddFormTarget) {
      this.addFormTarget.classList.remove('d-none');
    }
  }

  hideAddForm(event) {
    event.preventDefault();
    if (this.hasAddFormTarget) {
      this.addFormTarget.classList.add('d-none');
    }
  }
}
